export declare interface StudentData {
	group: string;
	_id: string;
	firstname: string;
	lastname: string;
	username: string;
	email: string;
}

export const emptyStudent = {
	group: '',
	_id: '',
	firstname: '',
	lastname: '',
	username: '',
	email: ''
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/models/Student.ts